import deburr from "lodash/deburr";
import orderBy from "lodash/orderBy";
import React from "react";
import { Loader, Table, TableCell } from "semantic-ui-react";
import { OrdersReportData } from "../../hooks/useOrdersReportData";
import { getReportClientName } from "../../utils";
import { OrdersTotalRows } from "./OrdersTotalRows";
import { TableClientRows } from "./TableClientRows";
import { TableHeaders } from "./TableHeaders";

interface OrdersReportTableProps {
    ordersReportData: OrdersReportData;
    isLoading: boolean;
}

export const OrdersReportTable: React.FC<OrdersReportTableProps> = ({
    ordersReportData,
    isLoading,
}) => {
    const orderedClientCodes = orderBy(ordersReportData.clientCodes, (clientCode) =>
        deburr(
            getReportClientName(
                ordersReportData.clientInformationByClientCode,
                clientCode,
            ).toLowerCase(),
        ),
    );

    return (
        <Table compact celled structured unstackable style={{ fontSize: "0.7rem" }}>
            <TableHeaders reportMonthsInOrder={ordersReportData.monthsInOrder} />
            <Table.Body>
                {isLoading && (
                    <Table.Row>
                        <TableCell colSpan={15} textAlign="center">
                            <Loader style={{ margin: "1rem" }} inline active />
                        </TableCell>
                    </Table.Row>
                )}
                {!isLoading &&
                    orderedClientCodes.map((clientCode) => (
                        <TableClientRows
                            key={clientCode}
                            clientCode={clientCode}
                            ordersReportData={ordersReportData}
                        />
                    ))}
                {!isLoading && <OrdersTotalRows ordersReportData={ordersReportData} />}
            </Table.Body>
        </Table>
    );
};
